import { Component } from '@angular/core';

@Component({
  selector: 'om-svg-phone-in-blue-circle',
  templateUrl: './svg-phone-in-blue-circle.component.html',
})
export class SvgPhoneInBlueCircle {
  constructor() {}
}
